
import { OrganType } from "@nkr/enums/organ-type";
import { DashIntakeStatus, DashSearchDateType } from "./dash-enums";

export interface IDashSearch {
    centerId                    ?: number,
    firstName                   ?: string,
    lastName                    ?: string,
    alias                       ?: string,
    email                       ?: string,
    dateOfBirth                 ?: string,
    filterStartDate              : string,
    filterEndDate                : string,
    includeNkr                  ?: boolean,
    includeDash                 ?: boolean,
    includeMiSite               ?: boolean,
    centerStatus                ?: number | null,
    disposition                 ?: number | null,
    coordinatorId               ?: number,
    organType                   ?: OrganType | null,
    followUpDays                ?: number | null,
    isLostInPwl                 ?: boolean | null,
    livingDonorPrioritization   ?: boolean,
    referred                    ?: boolean,
    donated                     ?: boolean,
    includeAllMs                ?: boolean,

    includeRemote               ?: boolean,
    dateSearchType              ?: DashSearchDateType,
    intakeStatuses              ?: DashIntakeStatus[],
    intendedFirstName           ?: string | null,
    intendedLastName            ?: string | null,
    intendedDob                 ?: string | null,
    isRemote                    ?: boolean | null,
    isInEmr                     ?: boolean | null,

    micrositeRecipientId        ?: number | null,
}